

export class AddQuestion{
    storybookId: number;
    question: string;
    answer1: string;
    answer2: string;
    answer3: string;
    answer4: string;
    correctAnswer: string;
    questionImage: string;
}